var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({backgroundColor:_vm.layout?.pageBackground?.color})},[(_vm.layout)?_c('section',{staticClass:"layout_two_banner"},[(_vm.layout.box1.image.preview)?_c('img',{staticClass:"main-image banner-image",attrs:{"src":_vm.layout.box1.image.preview,"alt":"Banner Image"}}):_vm._e()]):_vm._e(),(_vm.layout)?_c('section',{staticClass:"layout_two_pricing"},[_c('h2',{staticClass:"custom-heading",style:({
            fontSize: _vm.layout.box2.heading.fontSize + 'px',
            color: _vm.layout.box2.heading.color,
            // backgroundColor: layout.box2.heading.backgroundColor,
            fontFamily: _vm.layout.box2.heading.fontFamily,
            fontWeight: _vm.layout.box2.heading.bold ? 'bold' : 'normal'
        })},[_vm._v(_vm._s(_vm.layout.box2.heading.text))]),_c('table',{staticClass:"layout_two",style:({
            border: '2px solid ' + _vm.layout.box2.tableStyle.borderColor,
            fontSize: _vm.layout.box2.tableStyle.fontSize + 'px',
            fontFamily: _vm.layout.box2?.tableStyle?.fontFamily
        })},[_c('thead',[_c('tr',{style:({
                    backgroundColor: _vm.layout.box2?.tableStyle?.headerBg,
                    color: _vm.layout.box2?.tableStyle?.headerColor,
                    fontWeight: _vm.layout.box2?.tableStyle?.bold ? 'bold' : 'normal'
                })},[_c('th',{style:({
                        border: '1px solid ' + _vm.layout.box2.tableStyle.borderColor
                    })},[_vm._v("Title")]),_c('th',{style:({
                        border: '1px solid ' + _vm.layout.box2.tableStyle.borderColor
                    })},[_vm._v("Price")])])]),_c('tbody',_vm._l((_vm.layout.box2?.tableData),function(item,index){return _c('tr',{key:index,style:({
                    backgroundColor: _vm.layout.box2.tableStyle.cellBg,
                    color: _vm.layout.box2.tableStyle.cellColor,
                    border: '1px solid ' + _vm.layout.box2.tableStyle.borderColor
                })},[_c('td',{style:({
                        border: '1px solid ' + _vm.layout.box2.tableStyle.borderColor
                    })},[_vm._v(_vm._s(item.service))]),_c('td',{style:({
                        border: '1px solid ' + _vm.layout.box2.tableStyle.borderColor
                    })},[_vm._v(_vm._s(item.price))])])}),0)])]):_vm._e(),_c('section',{staticClass:"quote-box"},[(_vm.layout.box3?.textWithLink?.text)?_c('div',{staticClass:"quote-content",style:({
            fontSize: _vm.layout.box3?.textWithLink?.fontSize + 'px',
            color: _vm.layout.box3?.textWithLink?.color,
            fontFamily: _vm.layout.box3?.textWithLink?.fontFamily,
            backgroundColor: _vm.layout.box3?.textWithLink?.backgroundColor,
            fontWeight: _vm.layout.box3?.textWithLink?.bold ? 'bold' : 'normal'
        }),domProps:{"innerHTML":_vm._s(_vm.processQuoteLink(_vm.layout.box3.textWithLink.text))}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }